import type ICoProducer from 'interfaces/ICoProducer';
class CoProducer implements ICoProducer {
  public affiliate_manager: boolean = this.coproducer.affiliate_manager || false;
  public business_name: string = this.coproducer.business_name || '';
  public email: string = this.coproducer.email || '';
  public fiscal_document: boolean = this.coproducer.fiscal_document || false;
  public only_over_affiliates: boolean = this.coproducer.only_over_affiliates || false;
  public permission_refund: boolean = this.coproducer.permission_refund || false;
  public comission_type: string = this.coproducer.comission_type || 'P';
  public customer_id: number = this.coproducer.customer_id || 0;
  public comission_value: number = this.coproducer.comission_value || 0;
  public active: boolean = this.coproducer.active || false;
  public visibility_customer_email: boolean = this.coproducer.visibility_customer_email || false;
  public new: boolean = this.coproducer.new || false;
  public edited: boolean = this.coproducer.edited || false;
  public pending: boolean = this.coproducer.pending || false;
  public isDeliveryPartner: boolean = this.coproducer.isDeliveryPartner || false;

  constructor(private coproducer: Partial<ICoProducer> = {}) {}
}

export default CoProducer;
